import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const UserDelete = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M21.2998 21.95L19.1748 19.825M19.1748 19.825L17.0498 17.7M19.1748 19.825L21.2498 17.75M19.1748 19.825L16.9998 22M3.41016 22C3.41016 18.13 7.26018 15 12.0002 15C13.0402 15 14.0402 15.15 14.9702 15.43M17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
